import styled, { css } from 'styled-components';

export const GraphContainer = styled.div`
  position: relative;
  margin: auto;
  width: 100%;
  height: ${({ height }) => height};


  .recharts-cartesian-axis-line{
    stroke: rgba(214, 214, 214, 0.27);
    fill: rgba(214, 214, 214, 0.27);
  }

  .recharts-cartesian-grid {
    .recharts-cartesian-grid-horizontal,
    .recharts-cartesian-grid-vertical {
      line {
        stroke: rgba(214, 214, 214, 0.27);
        fill: rgba(214, 214, 214, 0.27);
      }
    }
  }

  .recharts-text.recharts-cartesian-axis-tick-value {
    fill: #9da3b3;
    font-size: 12px;
  }

  .recharts-cartesian-axis-tick text {
    font-weight: 100;
    font-size: 12px;
    line-height: 17px;
    stroke: ${({ theme }) => theme.colors.palette[2]};
  }

  ${({ theme, entityLines }) => createEntityCSS(entityLines, theme)};
`;

/* BAR GRAPH */
export function createEntityCSS(entityLines, theme) {
  const length = theme.colors.graphPalette.length;
  const distance = -1; // Moving in reverse
  let styles = '';
  let colorIdx;

  /*
    We'll determine the color index by pointing to the palette
    array in a circular manner, in reverse order. This way we'll
    never have a negative index, no matter how many entity items

    More on this here:
    https://stackoverflow.com/a/41274929/12663455
  */
  for (let i = 0; i < entityLines.length; i += 1) {
    colorIdx = ((length - i) + distance + length) % length;
    styles += `
      .recharts-bar-rectangle {
        path.bar_${entityLines[i]} {
          fill: ${theme.colors.graphPalette[colorIdx]}; 
        }
      }
      .recharts-bar.bar_${entityLines[i]} {
        path {
          fill: ${theme.colors.graphPalette[colorIdx]}; 
        }
      }
      .custom-tooltip-container {
        .custom-tooltip-container__value--${entityLines[i]} {
          color: ${theme.colors.graphPalette[colorIdx]};
        }
      }
      .recharts-legend-wrapper > ul {
        span:nth-of-type(${i + 1}n)::before {
          background-color: ${theme.colors.graphPalette[colorIdx]};
        }
      }
      .recharts-line.line_${entityLines[i]} {
        path, circle {
          stroke: ${theme.colors.graphPalette[colorIdx]};
        }
      }
     `;
  }

  return css`
    ${styles}
  `;
}

/* LEGEND */
export const StyledLegendItem = styled.span`
  display: inline-block;
  margin-right: 10px;
  font-size: 12px;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    background: ${({ theme }) => theme.colors.palette[7]}; /* default, but will be managed by createCSS */
    margin-right: 10px;
  }
`;

export const StyledLegendList = styled.ul`
  padding: ${({ top }) => top ? '0px 9px' : '0px'};
  margin: 0px;
  text-align: ${({ top }) => top ? 'left' : 'right'};

  ${StyledLegendItem} {
    ${({ top }) => top && css`
      height: 16px;
      width: 20%;
      margin-right: 0;
      margin-bottom: 14px;
    `};
  }
`;

/* TOOLTIP */
export const StyledTooltipContainer = styled.div`
  width: 200px;
  height: auto;
  margin: 0;
  line-height: 24px;
  border: 1px solid #f5f5f5;
  background-color: #ffffff;
  box-shadow: 0 5px 9px 0 rgba(0,0,0,0.02);
  padding: 10px;
  font-style: normal;
  font-weight: thin;
  border-radius: 5px;
`;

export const StyledTooltipLabel = styled.div`
  font-size: 14px;
  color: #3A4049;
  text-transform: capitalize;
`;

export const StyledTooltipValue = styled.div`
  font-size: 12px;
  color:  ${({ theme }) => theme.colors.palette[7]};
`;
